import React, { useContext } from 'react'
import { FaShoppingBag, FaWallet } from 'react-icons/fa'
import { FaLocationDot } from 'react-icons/fa6'
import { IoTimeSharp } from 'react-icons/io5'
import SuperAdminContext from '../../hooks/SuperAdminContext'
import { useNavigate } from 'react-router-dom'
import { TbNotes } from 'react-icons/tb'
import { AiFillTrademarkCircle } from 'react-icons/ai'
import { TfiMedallAlt } from 'react-icons/tfi'
import { BiMedal } from 'react-icons/bi'
import { RiMedal2Line, RiVerifiedBadgeLine } from 'react-icons/ri'
import { TbCalendarTime } from "react-icons/tb";


const JobCard = ({ jobSts, pricing_category, company_name, notes, recom_jobs, profile_image, jobHeading, postedOn, jobId, workplace, city, schedule, jobType, payment, cardDesc, selectedJobCard }) => {
    const {
        smallDevice
    } = useContext(SuperAdminContext);

    const pageRender = useNavigate();
 

    const handleCard = (id) => {
        selectedJobCard(id)
        if (smallDevice) {
            pageRender("/super_admin/jobs/job_details")
        }
    }

    return (
        <div className='cursorPointer' onClick={() => handleCard(jobId)} key={jobId}>
            <div className="d-flex align-items-center my-2 mt-4 ">
                <div className="flex-shrink-0">
                    <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${profile_image}`} alt="..." width={52} height={52} className='rounded-circle pe-none' />
                </div>

                <div className='d-inline-flex opened_closed_paused_Badge'>
                    <div className={`py-1 px-3 me-1 rounded-1 ${jobSts?.toLowerCase() === "opened" ? 'job-shortlisted' : null ||
                        jobSts?.toLowerCase() === "paused" ? 'job-contacted' : null ||
                            jobSts?.toLowerCase() === "closed" ? 'job-rejected' : null
                        }`
                    }>

                        <p className='m-0'>{jobSts?.toLowerCase() === "opened" ? 'Open' : null ||
                            jobSts?.toLowerCase() === "paused" ? 'Paused' : null ||
                                jobSts?.toLowerCase() === "closed" ? 'Closed' : null
                        }</p>
                    </div>
                </div>

                <div className="flex-grow-1 ms-3">
                    <h6 className='job-card-component-heading text-break col-9'>
                        {jobHeading}

                        {
                            notes !== "" && notes !== null ?
                                <div className="d-inline-block ps-2">
                                    <TbNotes className='fs-5 brand-color' title="Notes from 2nd Careers Experts" />
                                </div>
                                :
                                null
                        }

                        {
                            recom_jobs.length > 0 ?
                                <div className="d-inline-block ps-1">
                                    <AiFillTrademarkCircle className='fs-5 text-success' title="Recommended" />
                                </div>
                                :
                                null
                        }

                    </h6>
                    <p className='job-card-posted-time m-0'>{company_name}</p>
                    <p className='job-card-posted-time m-0'>Posted on {postedOn}</p>
                </div>
            </div>
            <div>
                <div className="row justify-content-around  card-company-details-icon mt-4">
                    <label className="fs-7 card-inner-details col-6 col-sm-3 col-lg-6 px-2 px-sm-0 py-1 py-sm-0 text-start text-sm-center text-lg-start ps-lg-3">
                        <FaLocationDot className="me-2 text-success" />
                        {
                            `${workplace}-${city}`
                        }
                    </label>
                    <label className="fs-7 card-inner-details col-6 col-sm-3 col-lg-6 px-2 px-sm-0 py-1 py-sm-0 text-start text-sm-center text-lg-start ps-lg-3">
                        <FaShoppingBag className="me-2 text-warning" />
                        {schedule}
                    </label>
                    <label className="fs-7 card-inner-details col-6 col-sm-3 col-lg-6 px-2 px-sm-0 py-1 py-sm-0 text-start text-sm-center text-lg-start ps-lg-3">
                        <IoTimeSharp className="me-2 text-primary" />
                        {jobType}
                    </label>
                    <label className="fs-7 card-inner-details col-6 col-sm-3 col-lg-6 px-2 px-sm-0 py-1 py-sm-0 text-start text-sm-center text-lg-start ps-lg-3">
                        <FaWallet className="me-2 text-warning" />
                        {payment === "Y" ? "Paid" : "Volunter"}
                    </label>
                </div>
                <p className='mt-4 job-card-description'>{cardDesc}</p>
            </div>

            <div className='flex-shrink-0 appliedOrSaved'>
                <div
                    className={`py-1 px-3 appliedOrSaved-borderRadius
                  ${pricing_category === "unpaid" ? 'basic-plan' : null ||
                            pricing_category === "trialing" ? 'basic-plan' : null ||
                                pricing_category === "Basic" ? 'basic-plan' : null ||
                                    pricing_category === "Premium" ? 'premium-plan' : null ||
                                        pricing_category === "Platinum" ? 'platinum-plan' : null ||
                                            pricing_category === "cancelled" ? 'platinum-plan' : null ||
                                                pricing_category === "incomplete" ? 'platinum-plan' : null ||
                                                    pricing_category === "complete" ? 'platinum-plan' : null ||
                                                        pricing_category === "canceled" ? 'platinum-plan' : null
                        }`
                    }>

                    <div className='m-0 px-2'>{pricing_category === "unpaid" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                        pricing_category === "trialing" ? <span><RiVerifiedBadgeLine className='fs-5' /> Free trial</span> : null ||
                            pricing_category === "Basic" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                                pricing_category === "complete" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                                    pricing_category === "Premium" ? <span><BiMedal className='fs-5' /> Premium</span> : null ||
                                        pricing_category === "Platinum" ? <span><RiMedal2Line className='fs-5' /> Platinum</span> : null ||
                                            pricing_category === "cancelled" ? <span><TbCalendarTime className='fs-5' /> Plan Canceled</span> : null ||
                                                pricing_category === "canceled" ? <span><TbCalendarTime className='fs-5' /> Plan Canceled</span> : null ||
                                                    pricing_category === "incomplete" ? <span><TbCalendarTime className='fs-5' /> Expired</span> : null
                    }</div>
                </div>
            </div>
        </div>
    )
}

export default JobCard